import { Form } from "react-router-dom";
import React, { useState, useEffect, useRef } from "react";
import { Button, Modal, Radio, Select, Spin } from "antd";
import { Icon } from "@vds/icons";
import Grid2 from "@mui/material/Unstable_Grid2/Grid2";
import { createLocation, updateLocation } from "../../../global/utility/Utils";
import ValidationIcon from "../../../global/components/ValidationIcon";
import {Input} from "@vds/inputs"
import {
  getInputClassNames,
  ErrorMessage,
} from "../../../global/components/ValidationIcon";
import { SearchBox } from "@mapbox/search-js-react";
import ToastNotification from "../../../global/components/ToastNotification";
import { Switch } from "antd";
import {MAX_CHAR_LIMITS,getCharLimitMsgIfExceeded} from "../../../global/constants/inputLimits";
import { useSelector, useDispatch } from "react-redux";
import { setLocationData, fetchRequest, updateModal, resetLocationData, resetLocationDataOnly, fetchRequestAll } from '../../../store/actions/location';
import { mapboxToken } from "../../../configuration";
import { handleClosePopup } from "./locationUtils";
import { handleSubmit as handleSubmitImport } from "./locationUtils";
import { DropDown } from "../wrapperComponents/DropDown";
import { RadioButtonGroup, RadioButton } from '@vds/radio-buttons';
import { Tooltip } from "@vds/tooltips";
import { create } from "@mui/material/styles/createTransitions";


const InventoryLocation = ({visible, selectedCloneOrganization,state,onOrgCreated}) => {
  const mapBoxAccessToken = mapboxToken;
  const dispatch = useDispatch();
  const [dataList, setDataList] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);
  const [showNotification, setShowNotification] = useState(false);
  const [notificationProps, setNotificationProps] = useState({});
  const mapRef = useRef(null);
  const [boundingBox, setBoundingBox] = useState(null);
  const boundingBoxRef = useRef(boundingBox);
  const centerRef = useRef([-74.533564, 40.725683]);
  const location_data = useSelector((state) => state.location.location_data);
  const initialData = useSelector((state) => state.location.initialState);
  const current_modal = useSelector(state => state.location?.current_modal);
  const locationList = useSelector((state) => state.location.data.locationsAll);
  const [filteredLocationList, setFilteredLocationList] = useState([]);
  const [filteredLocationFloorsList, setFilteredLocationFloorsList] = useState([]);
  const [fetchRequestAllCalledForThisModal, setFetchRequestAllCalledForThisModal] = useState(false);
  const isLoading = useSelector((state) => state.location.isLoading);
  const apiLoading = useSelector((state) => state.location.isApiLoading);

  useEffect(()=>{
    if(location_data?.action_type==='edit' || location_data?.cloneAction===true || location_data?.backButtonClicked===true){
    setFormData({
      locationName: location_data?.name || "",
      address: location_data?.address || "",
      gpslocation: `${location_data?.lat_value},${location_data?.long_value}` || "",
      lattitude: location_data?.lat_value || "",
      longitude: location_data?.long_value || "",
      disable: location_data?.disable || false,
      geofench: location_data?.radius || 500,
      adjustGeofenceMap: location_data?.adjustGeofenceMap || false
    })}
  },[location_data])

  useEffect(()=>{
    boundingBoxRef.current = boundingBox;
  }, [boundingBox])

  useEffect(()=>{
    if(location_data?.createtype==='NewFloor' ||  location_data?.createtype==='NewZone'){
      const filteredList = locationList?.filter((item) => item?.createtype === "inventory_location")?.map((loc) => ({name: loc?.name, id: loc?.id}));
      setFilteredLocationList(filteredList);
      if(location_data?.createtype==='NewZone'){
        const filteredFloorsList = locationList?.filter(loc => Object.keys(loc?.floors || {}).length > 0 && loc?.createtype === "inventory_location").map((loc) => ({name: loc?.name, id: loc?.id}));
        setFilteredLocationList(filteredFloorsList);
        dispatch(setLocationData({ ...location_data, exceptionalBackRoute : true }));
      }
    }
  }, [location_data?.createtype, locationList])

  const initialFormData = {
    locationName: "",
    address: "",
    gpslocation: "",
    lattitude:'',
    longitude:'',
    disable: false,
    // orgId: org_id!==undefined?org_id:"",
    // locationtype: "Plant",
    geofench: 500,
    adjustGeofenceMap:false
  };

  const next_modal = useSelector(state => state.location.next_modal);

  useEffect(() => {
    if (!location_data?.backButtonClicked && location_data?.action_type=='add' ) {
      dispatch(setLocationData({ ...location_data, createtype: 'inventory_location' }))
      dispatch(resetLocationDataOnly({ createtype: 'inventory_location', next_modal: 'AddFloor' }));
    }
    return () => {
      setFetchRequestAllCalledForThisModal(false);
    }
  }, []);

  const [formData, setFormData] = useState(initialFormData);
  useEffect(()=>{
    centerRef.current = {formData: formData, center : [formData?.longitude, formData?.lattitude]};
  },[formData?.longitude, formData?.lattitude, formData])
  useEffect(()=>{
    if(formData?.longitude==='' && formData?.lattitude==='' && formData?.adjustGeofenceMap===true){
        setFormData({ ...formData, address: "1 Verizon Way, Basking Ridge, New Jersey 07920, United States", gpslocation: "40.725683,-74.533564", longitude: -74.533564, lattitude: 40.725683 });
    }
  },[formData?.adjustGeofenceMap])

  const [errors, setErrors] = useState({
    locationName: "initial",
    address: "initial",
    gpslocation: "initial",
    lattitude:"initial",
    longitude:"initial",
    locationNameDropDown: "initial",
    floorNameDropDown: "initial",
  });
  const [mapBoxTheme, setMapBoxTheme] = useState({
    cssText: `
            .Input {
                height: 48px;
                font-size: 1rem;
                font-weight: 400;
                color: #212529;
                font-family: system-ui;
            }
            .ClearBtn {
                display: none !important;
            }
        `,
    variables: {
      unit: "14px",
      padding: "0.5em",
      border: "1px solid rgba(111, 113, 113, 1)",
      borderRadius: "4px",
      boxShadow: "none",
    },
  });

  const [rerender, setReRender] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setReRender(!rerender);
    }, 1000);
    return () => clearTimeout(timer);
  }, [formData.lattitude, formData.longitude, formData.geofench, mapRef.current]);


  const handleAdjustGeofenceMap = (val) => {
    setFormData({
      ...formData,
      adjustGeofenceMap: val,
    })
  }

  useEffect(() => {
    if ((location_data?.createtype === 'NewFloor' || location_data?.createtype === 'NewZone' || location_data?.createtype === 'AddFloor') && !fetchRequestAllCalledForThisModal && !location_data?.backButtonClicked) {
      dispatch(fetchRequestAll());
      setFetchRequestAllCalledForThisModal(true);
    }
  }, [location_data?.createtype])

  const handleChange = (e) => {
    let { name, value } = e.target || { name: "address", value: e };
    let gpslocation = formData.gpslocation;
    if(name=="longitude"){
      gpslocation = `${formData?.lattitude},${value}`;
    }else if(name=="lattitude"){
      gpslocation = `${value},${formData?.longitude}`;
    }else if(name=="geofench"){
      if(!isNaN(value)){
        value = Math.floor(value);
      }
    }

    setFormData({ ...formData, [name]: value, gpslocation });
    let tempErrors = { ...errors };
    switch (name) {
      case "locationName":
        tempErrors.locationName = value ? "initial" : "Please enter a location name";
        break;
      case "address":
        tempErrors.address = value && value!=="" ? "" : "Please enter address";
        break;
      case "gpslocation":
        const gpsPattern = /^-?\d+(\.\d+)?$/;
        tempErrors.gpslocation = gpsPattern.test(value) ? "" : "Please enter a valid GPS location";
        break;
      case "geofench":
        const geofenchPattern = /^(0|[1-9][0-9]{0,5}|1000000)$/;
        tempErrors.geofench = value == 0 ? "radius can't be less than 1" : geofenchPattern.test(value) ? "" : "Kindly enter a valid value for geofence"
        break;
      default:
        break;
    }
    if (name === "locationName") {
      const charLimitMessage = getCharLimitMsgIfExceeded("CATEGORY_TEXT", value);
      if (charLimitMessage) {
        tempErrors.locationName = charLimitMessage;
      }
    }
    setErrors(tempErrors);
  };

  const validate = () => {
    let tempErrors = { ...errors };
    tempErrors.locationName = formData.locationName
      ? "initial"
      : "Please enter a location name";
    tempErrors.address = formData.address ? "" : "Please enter address";
    if (!formData?.address) {
      setMapBoxTheme((prev) => ({
        ...prev,
        variables: { ...prev.variables, border: "1px solid rgb(186, 38, 38)" },
      }));
    }
    tempErrors.gpslocation = formData.gpslocation
      ? ""
      : "Please enter GPS location";
    tempErrors.lattitude = formData.lattitude ? "" : "Please enter lattitude";
    tempErrors.longitude = formData.longitude ? "" : "Please enter longitude";

    setErrors(tempErrors);
    if (Object.values(tempErrors).some((x) => x !== "" && x !== "initial")  && location_data?.createtype==='inventory_location') {
      setNotificationProps({
        type: 'error',
        message: 'Add location',
        description: 'invalid-form-data',
        duration: 1,
        style: { backgroundColor: '#FFECE0', color: '#155724' },
      });
      setShowNotification(true);
      setTimeout(() => {
        setShowNotification(false);
      }, 1000);
      return true;
    } else {
      return false;
    }
  }

  const handleSubmit = async () => {
    if(location_data?.createtype=='inventory_location'){
      delete errors.locationNameDropDown;
    }
    const validation = validate();
    if (validation) return;
    if (!location_data?.addfloormap) {
      const { isdeleteimage, addgateway, deleteImageResponse, gateway, isUploadingImage, uploadImageResponse, zoneCoordinates, zoneName, fetchImageResponse, ...rest } = location_data;
      const newItem = {
        ...rest,
        name: formData.locationName,
        address: formData.address,
        adjustgeofencemap: formData.adjustGeofenceMap,
        lat_value: formData.lattitude,
        long_value: formData.longitude,
        radius: formData.geofench,
        createtype: location_data?.createtype
      };
      const response = await createLocation(newItem);
      if (Array.isArray(response) && response?.length > 0 && response[0]?.id) {
        dispatch(fetchRequest(10));
        setNotificationProps({
          type: 'success',
          message: 'Add location',
          description: `Location "${response[0]?.name || response?.tags[0]?.name}" created successfully`,
          duration: 1,
          style: { backgroundColor: '#d4edda', color: '#155724' },
        });
        setShowNotification(true);
        setTimeout(() => {
          setShowNotification(false);
          dispatch(updateModal({ current_modal: '' }));
          setFormData(initialFormData);
        }, 1000);
      } else {
        setNotificationProps({
          type: 'error',
          message: 'Add location',
          description: "Location created failed",
          duration: 1,
          style: { backgroundColor: '#FFECE0', color: '#155724' },
        });
        setShowNotification(true);
        setTimeout(() => {
          setShowNotification(false);
        }, 1000);
      }

    } else {
      dispatch(setLocationData({
        ...location_data,
        name: formData.locationName,
        address: formData.address,
        adjustgeofencemap: formData.adjustGeofenceMap,
        lat_value: formData.lattitude,
        long_value: formData.longitude,
        radius: formData.geofench,
      }))
      setTimeout(()=>dispatch(updateModal({ current_modal: next_modal })),0);
    }
  };

  const handleSearchRetrieve = (res) => {
    if (
      res?.features &&
      res.features.length > 0 &&
      res.features[0]?.properties?.coordinates
    ) {
      setMapBoxTheme((prev) => ({
        ...prev,
        variables: { ...prev.variables, border: "1px solid rgb(99, 184, 132)" },
      }));

      const lattitude = res.features[0].properties.coordinates.latitude;
      const longitude = res.features[0].properties.coordinates.longitude;
      const tempErrors = {...errors};
      const lattitudePattern = /^(-?[0-8]?\d(\.\d+)?|90(\.0+)?)$/;
      tempErrors.lattitude = lattitudePattern.test(res.features[0].properties.coordinates.latitude) ? "" : "Kindly enter a valid value for lattitude";
      const longitudePattern = /^(-?(1[0-7]\d|[0-9]?\d)(\.\d+)?|180(\.0+)?)$/;
      tempErrors.longitude = longitudePattern.test(res.features[0].properties.coordinates.longitude) ? "" : "Kindly enter a valid value for longitude";
      setErrors(tempErrors);

      setFormData((prev) => ({
        ...prev,
        address: res.features[0].properties.full_address,
        gpslocation: `${res.features[0].properties.coordinates.latitude},${res.features[0].properties.coordinates.longitude}`,
        longitude: res.features[0].properties.coordinates.longitude,
        lattitude: res.features[0].properties.coordinates.latitude,
        disable: true
      }));
      setErrors((prev) => ({
        ...prev,
        gpslocation: "",
      }));
    }
  };

  const handleSuggestError = (res) => {
    if (res.suggestions.length === 0) {
      setMapBoxTheme((prev) => ({
        ...prev,
        variables: { ...prev.variables, border: "1px solid rgb(186, 38, 38)" },
      }));
      setErrors((prev) => ({
        ...prev,
        address: "Please Search valid address and select",
      }));
    }
  };

  const resetErrors = () => {
    setErrors({
      locationName: "initial",
      address: "initial",
      gpslocation: "initial",
      lattitude: "initial",
      longitude: "initial",
    })
  };

  useEffect(()=>{
    setMapBoxTheme((prev) => ({
      ...prev,
      variables: { ...prev.variables, border: "1px solid rgba(111, 113, 113, 1)" },
    }));

  },[visible]);
  useEffect(() => {
    if (state) {
      if (state.hasOwnProperty("org_name") && state.hasOwnProperty("org_id")) {
        setSelectedItem({
          organization: state?.org_name,
          orgId: state?.org_id,
          geofench:500
        });
        setFormData({
          organization: state?.org_name,
          orgId: state?.org_id,
          geofench:500
        });
      } else {
        setSelectedItem({
          locationName: selectedCloneOrganization ? "" : state?.name || state?.tags[0]?.name || "",
          address: state?.address || state?.tags[0]?.address || "",
          lattitude: Array.isArray(state?.tags) && state?.tags?.length > 0 && state?.tags[0]?.lat_value ? state?.tags[0]?.lat_value :  state?.lat_value || "",
          longitude: Array.isArray(state?.tags) && state?.tags?.length > 0 &&state?.tags[0]?.long_value ? state?.tags[0]?.long_value :  state?.long_value || "",
          gpslocation: Array.isArray(state?.tags) && state?.tags?.length > 0 && state?.tags[0]?.lat_value
            ? state?.tags[0]?.lat_value + "," + state?.tags[0]?.long_value
            : state?.lat_value + "," + state?.long_value || "",
          geofench: state?.radius || state?.tags[0]?.radius,
          adjustGeofenceMap: Array.isArray(state?.tags) && state?.tags?.length > 0 && state?.tags[0]?.adjustgeofencemap ? state?.tags[0]?.adjustgeofencemap :  state?.adjustgeofencemap
        });
        setFormData({
          id: state?.id,
          kind: state?.kind === "ts.tag.site" ? state?.kind : state?.tags[0]?.kind || "",
          locationName: selectedCloneOrganization ? "" : state?.name || state?.tags[0]?.name || "",
          address: state?.address || state?.tags[0]?.address || "",
           lattitude: Array.isArray(state?.tags) && state?.tags?.length > 0 && state?.tags[0]?.lat_value ? state?.tags[0]?.lat_value : state?.lat_value || "",
          longitude: Array.isArray(state?.tags) && state?.tags?.length > 0 && state?.tags[0]?.long_value ? state?.tags[0]?.long_value : state?.long_value || "",
          gpslocation: Array.isArray(state?.tags) && state?.tags?.length > 0 && state?.tags[0]?.lat_value
            ? state?.tags[0]?.lat_value + "," + state?.tags[0]?.long_value
            : state?.lat_value + "," + state?.long_value ||  "",
          geofench: state?.radius || state?.tags[0]?.radius || "",
          adjustGeofenceMap: Array.isArray(state?.tags) && state?.tags?.length > 0 && state?.tags[0]?.adjustgeofencemap ? state?.tags[0]?.adjustgeofencemap :  state?.adjustgeofencemap
        });
      }
    }
  }, [state]);

  return (
    <>
       <Modal
      title=""
      open={visible}
      onCancel={() => {handleClosePopup({dispatch});setFormData(initialFormData);resetErrors();}}

      footer={[
        <Grid2
          container
          marginTop={0}
          marginBottom={0}
          spacing={2}
          columns={{ xs: 12 }}
        >
          <Grid2 item xs={12} sm={6} md={6} lg={6}>
            <div className="mb-0">
              <Button
                className="custom-button-cancel"
                type="default"
                onClick={() => {handleClosePopup({dispatch});setFormData(initialFormData);resetErrors();}}
                shape="round"
                style={{ fontWeight: "bold", width: "100%" }}
                size={"large"}
              >
                Cancel
              </Button>
            </div>
          </Grid2>
          <Grid2 item xs={12} sm={6} md={6} lg={6}>
            <div className="mb-0">
              <Button
                className="custom-button-save"
                type="primary"
                onClick={
                  (location_data?.createtype === 'NewFloor' || location_data?.createtype === "NewZone") ?
                    () => { 
                      const tempErrors = { ...errors };
                      if (filteredLocationList.length === 0) {
                        tempErrors.locationNameDropDown = "No location available. Please create a location to add a zone.";
                        setErrors(tempErrors);
                      } else if (location_data?.id == undefined) {
                        tempErrors.locationNameDropDown = "Please select a location.";
                        setErrors(tempErrors);
                      } else {
                        tempErrors.locationNameDropDown = "initial";
                        setErrors(tempErrors);
                      }

                      if (location_data?.createtype == 'NewZone') {
                        if(Object.keys(location_data?.floors)?.length === 0) {
                          tempErrors.floorNameDropDown = "No floor map available. Please add a floor to the location.";
                          setErrors(tempErrors);
                        } else if(location_data?.selectedFloorKey==undefined){
                          tempErrors.floorNameDropDown = "Please select a floor.";
                          setErrors(tempErrors);
                        }else{
                          tempErrors.floorNameDropDown = "initial";
                          setErrors(tempErrors);
                        }
                      }

                      if (location_data?.createtype === "NewZone") {
                        if ((tempErrors.locationNameDropDown !== "initial" && tempErrors.locationNameDropDown !== "") || (tempErrors.floorNameDropDown !== "initial" && tempErrors.floorNameDropDown !== "")) {
                          return;
                        }
                      } else if (location_data?.createtype === "AddFloor" || location_data?.createtype == 'NewFloor') {
                        if (tempErrors.locationNameDropDown !== "initial" && tempErrors.locationNameDropDown !== "") {
                          return;
                        }
                      }

                      if(location_data?.createtype != 'NewFloor' && location_data?.createtype != 'NewZone'){
                      dispatch(setLocationData({
                        ...location_data,
                        name: formData.locationName,
                        address: formData.address,
                        adjustgeofencemap: formData.adjustGeofenceMap,
                        lat_value: formData.lattitude,
                        long_value: formData.longitude,
                        radius: formData.geofench,
                      }));
                    }
                      dispatch(updateModal({ current_modal: location_data?.createtype == 'NewFloor' || location_data?.createtype == 'inventory_location'? 'AddFloor' : 'AddZone' })); }
                    :
                    location_data?.action_type === 'edit' ?
                      () => {
                        if(validate()) return;
                        if (location_data?.addfloormap == true) {
                          if (location_data?.id == undefined) {
                            setErrors({ ...errors, locationNameDropDown: "Please select a location" });
                            return;
                          }
                          dispatch(setLocationData({
                            ...location_data,
                            name: formData.locationName,
                            address: formData.address,
                            adjustgeofencemap: formData.adjustGeofenceMap,
                            lat_value: formData.lattitude,
                            long_value: formData.longitude,
                            radius: formData.geofench,
                          }));
                          setTimeout(()=>dispatch(updateModal({ current_modal: location_data?.createtype == 'NewFloor' || location_data?.createtype == 'inventory_location'? 'AddFloor' : 'AddZone' })),0);
                        } else {
                          const location_data_temp = {
                            ...location_data,
                            name: formData.locationName,
                            address: formData.address,
                            adjustgeofencemap: formData.adjustGeofenceMap,
                            lat_value: formData.lattitude,
                            long_value: formData.longitude,
                            radius: formData.geofench,
                          };
                          handleSubmitImport(location_data_temp, dispatch, resetLocationData, updateLocation, setNotificationProps, setShowNotification);
                        }

                      }
                      :
                      () => { handleSubmit(); }
                }
                shape="round"
                style={{
                  width: "100%",
                  backgroundColor: "black",
                  color: "white",
                  fontWeight: "bold",
                }}
                size={"large"}
              >
                 {
                  (location_data?.addfloormap === true || location_data?.createtype === 'NewFloor' || location_data?.createtype === "NewZone") ? "Next" : "Save"
                 }
              </Button>
            </div>
          </Grid2>
        </Grid2>,
      ]}
      width={680}
      className="custom-modal-inventoryLocation"
    >
      {location_data?.createtype=='inventory_location' && <button type="button" className="ant-modal-back" aria-label="back" onClick={() => {
        if(location_data?.action_type==='edit' || location_data?.cloneAction===true){
          dispatch(setLocationData({ ...location_data}));
          dispatch(updateModal({current_modal: 'inventory_location_view'}))
          return;
        }
        dispatch(updateModal({current_modal: 'locationOptPopup'}))
      }}><Icon name="left-arrow" size={"small"}/></button>}

       {showNotification && (
          <ToastNotification
            type={notificationProps.type}
            message={notificationProps.message}
            description={notificationProps.description}
            duration={notificationProps.duration}
            style={notificationProps.style}
          />
        )}
       <div style={{ marginBottom: "5px", marginTop:"5px" }}>
          {
            location_data?.action_type !== 'edit' && <p className={"inventory-location-popup-title"}>
               Add Location
            </p>
          }

        <h2 className={"font-face-vzb page-header-location"}>
           {location_data?.action_type !== 'edit' ? 'Inventory Location' : 'Edit Location'}
        </h2>
      </div>
        <Spin spinning={isLoading || apiLoading} size="large" tip="Loading...">
          <Form>
            <Grid2
              container
              marginTop={1}
              marginBottom={2}
              spacing={1}
              columns={{ xs: 12 }}
              style={{ marginTop: "24px" }}
            >
              {location_data?.action_type == 'add' && <Grid2 item xs={12} sm={12} md={12} lg={12} direction="row" style={{ marginBottom: "12px" }}>
                <RadioButtonGroup
                  name="locationType"
                  value={location_data?.createtype}
                  onChange={(e) => {
                    const value = e?.target?.value;
                    if (value === 'inventory_location') {
                      setFormData(initialFormData);
                      dispatch(resetLocationDataOnly({ createtype: value, next_modal: 'AddFloor' }));
                    } else {
                      dispatch(setLocationData({
                        ...location_data,
                        createtype: value,
                        next_modal: value === 'NewZone' ? 'AddZone' : 'AddFloor'
                      }));
                    }
                  }}
                  style={{ display: "flex", flexDirection: "column", gap: 12 }}
                  className="ats-radio-group align-left-ats-radio-group"
                >
                  <RadioButton
                    name="locationType"
                    value="inventory_location"
                    disabled={false}
                    label={
                      <div className="d-flex flex-column justify-content-center align-items-start" >
                        <div
                          style={{
                            fontFamily: "VerizonNHGDSBold",
                            fontWeight: "700",
                            fontSize: "16px",
                            lineHeight: "20px",
                            letterSpacing: "0.5px",
                          }}
                        >
                          New Location
                        </div>
                        <div
                          style={{
                            fontFamily: "Verizon NHG eDS",
                            fontWeight: "400",
                            fontSize: "16px",
                            lineHeight: "20px",
                            letterSpacing: "0.5px",
                          }}
                        >
                          Add a new building or site
                        </div>
                      </div>
                    }
                  />
                  <RadioButton
                    name="locationType"
                    value="NewFloor"
                    disabled={false}
                    label={
                      <div className="d-flex flex-column justify-content-center align-items-start" >
                        <div
                          style={{
                            fontFamily: "VerizonNHGDSBold",
                            fontWeight: "700",
                            fontSize: "16px",
                            lineHeight: "20px",
                            letterSpacing: "0.5px",
                          }}
                        >
                          New Floor
                        </div>
                        <div
                          style={{
                            fontFamily: "Verizon NHG eDS",
                            fontWeight: "400",
                            fontSize: "16px",
                            lineHeight: "20px",
                            letterSpacing: "0.5px",
                          }}
                        >
                          Add a new floor to an existing location
                        </div>
                      </div>
                    }
                  />
                  <RadioButton
                    name="locationType"
                    value="NewZone"
                    disabled={false}
                    label={
                      <div className="d-flex flex-column justify-content-center align-items-start" >
                        <div
                          style={{
                            fontFamily: "VerizonNHGDSBold",
                            fontWeight: "700",
                            fontSize: "16px",
                            lineHeight: "20px",
                            letterSpacing: "0.5px",
                          }}
                        >
                          New zone
                        </div>
                        <div
                          style={{
                            fontFamily: "Verizon NHG eDS",
                            fontWeight: "400",
                            fontSize: "16px",
                            lineHeight: "20px",
                            letterSpacing: "0.5px",
                          }}
                        >
                          Add a new area (zone) to an existing location
                        </div>
                      </div>
                    }
                  />
                </RadioButtonGroup>
              </Grid2>}
              {
                location_data?.createtype === "inventory_location" && (
                  <>
                    <Grid2 item xs={12} sm={12} md={12} lg={12} direction="row">
                      <div className="mb-1">
                        <label className="input-label-user">Location name</label>
                        <div>
                          <Input
                            type="text"
                            id="locationName"
                            name="locationName"
                            value={formData.locationName}
                            maxLength={MAX_CHAR_LIMITS.CATEGORY_TEXT}
                            required={false}
                            onChange={handleChange}
                            error={errors.locationName !== "initial"}
                          />
                          <ErrorMessage
                            fieldName="locationName"
                            className={"ats-error-message-imp"}
                            errors={{ 'locationName': errors['locationName'] !== '' ? errors['locationName'] : '' }}
                          />
                        </div>
                      </div>
                      <div className="mb-1">
                        <label className="input-label-user">Address</label>
                        <div className="input-container">
                          <SearchBox
                            accessToken={mapBoxAccessToken}
                            options={{
                              language: "en",
                              country: "US,CA,MX",
                            }}
                            value={formData.address}
                            onChange={handleChange}
                            onRetrieve={handleSearchRetrieve}
                            onSuggest={handleSuggestError}
                            theme={mapBoxTheme}
                            className={getInputClassNames("address", formData, errors)}
                            id="address"
                            name="address"
                          />
                          <ValidationIcon
                            fieldName="address"
                            formData={formData}
                            errors={errors}
                          />
                        </div>
                        <ErrorMessage fieldName="address" className={'ats-error-message-imp'} errors={errors} />
                      </div>
                      <div
                        className="d-flex flex-row justify-content-start align-items-center"
                        style={{
                          padding: "8px 0px",
                          margin: "4px 0px",
                        }}
                      >
                        <div
                          className="font-face-vzw"
                          style={{
                            fontFamily: "VerizonNHGDSBold",
                            fontWeight: "700",
                            fontSize: "16px",
                            leadingTrim: "NONE",
                            lineHeight: "20px",
                            letterSpacing: "0.5px",
                          }}
                          position="relative"
                        >
                          Add floor map
                          <Tooltip
                            title=""
                            size="medium"
                            surface="light"
                            className='InventoryLocationTooltip'
                          >
                            <span className="font12Location" style={{ color: "#000" }}>
                              Upload a floor map for better tracking.
                            </span>
                          </Tooltip>
                        </div>
                        <div className="px-2">
                          <Switch
                            style={
                              location_data?.addfloormap == true
                                ? {
                                  backgroundColor: "#008331",
                                }
                                : {
                                  backgroundColor: "#d8dada",
                                }
                            }
                            checked={location_data?.addfloormap == true}
                            onChange={(e) => dispatch(setLocationData({ ...location_data, addfloormap: e }))}
                          />
                        </div>
                      </div>
                      {location_data?.addfloormap !== true ? (
                        <Grid2 style={{ display: "flex" }}>
                          <div className="mb-1" style={{ width: "46%", marginRight: "3%" }}>
                            <label className="input-label-user">Lattitude</label>
                            <div className="input-container locationLatLong">
                              <Input
                                id={`lattitude`}
                                value={
                                  formData.lattitude || ""
                                }
                                onChange={handleChange}
                                required={false}
                                readOnly={true}
                                type="number"
                              />
                            </div>
                            <ErrorMessage fieldName="lattitude" className={'ats-error-message-imp'} errors={errors} />
                          </div>
                          <div className="mb-1" style={{ width: "46%", marginRight: "3%" }}>
                            <label className="input-label-user">Longitude</label>
                            <div className="input-container locationLatLong">
                              <Input
                                id={`longitude`}
                                value={
                                  formData.longitude || ""
                                }
                                onChange={handleChange}
                                required={false}
                                readOnly={true}
                                type="number"
                              />
                            </div>
                            <ErrorMessage fieldName="longitude" className={'ats-error-message-imp'} errors={errors} />
                          </div>
                          <div className="mb-1" style={{ width: "46%" }}>
                            <label className="input-label-user">Geofence Radius(meters)</label>
                            <div className="input-container">
                              <Input
                                type="text"
                                id="geofench"
                                name="geofench"
                                value={formData.geofench}
                                onChange={handleChange}
                                error={!!errors.geofench}
                                errorText={errors.geofench}
                              />
                            </div>
                          </div>
                        </Grid2>
                      ) : ''}
                    </Grid2>
                  </>
                )
              }
              {
                (location_data?.createtype == "AddFloor" || location_data?.createtype == "NewFloor" || location_data?.createtype == "NewZone") && (
                  <>
                    <DropDown
                      label="Location"
                      value={location_data?.id}
                      name={"locationNameDropDown"}
                      onChangeFn={
                        (value) => { setErrors({ ...errors, locationNameDropDown: "initial" }); locationList.forEach(loc => { if (loc.id == value) { dispatch(setLocationData({ ...location_data, ...loc, createtype: location_data?.createtype == "AddFloor" ? "NewFloor" : location_data?.createtype })); } }) }
                      }
                      placeholder={"Select a location"}
                      error={errors['locationNameDropDown'] == "initial" ? '' : true}
                      errors={{
                        'locationNameDropDown': errors['locationNameDropDown'] !== '' ? errors['locationNameDropDown'] : ''
                      }}
                      options={filteredLocationList.map((loc) => ({ label: loc.name, value: loc.id }))}
                    />
                    {location_data?.createtype == "NewZone" && (
                      <DropDown
                        label="Floor"
                        value={location_data?.floors[location_data?.selectedFloorKey]?.name}
                        name={"floorNameDropDown"}
                        onChangeFn={
                          (value) => { setErrors({ ...errors, floorNameDropDown: "initial" }); dispatch(setLocationData({ ...location_data, selectedFloorKey: value })); }
                        }
                        placeholder={"Select a floor"}
                        error={errors['floorNameDropDown'] == "initial" ? '' : true}
                        errors={{
                          'floorNameDropDown': errors['floorNameDropDown'] !== '' ? errors['floorNameDropDown'] : ''
                        }}
                        options={Object.keys(location_data?.floors).map((floorKey) => ({ label: location_data?.floors[floorKey]?.name, value: floorKey }))}
                      />)
                    }
                  </>
                )
              }
            </Grid2>
          </Form>
        </Spin>
      </Modal>
    </>
  );
};

export default InventoryLocation;
